import AuditLogReport from '../../slices/report/AuditLogReport'
import InOutLogReport from '../../slices/report/InOutLogReport'
import UserStatusReport from '../../slices/report/UserStatusReport'
import AdminReport from '../../slices/report/AdminReport'

const reportReducer = {
    auditLogReport: AuditLogReport,
    inOutLogReport: InOutLogReport,
    userStatusReport: UserStatusReport,
    adminReport: AdminReport,
};

export default reportReducer;